import authClient from '../../../../api/authClient'

export async function requestForgotPasswordOtp(params) {
  const payload = typeof params === 'string' ? { email: params } : params
  const { data } = await authClient.post('/auth/forgot-password', payload)
  return data
}

export async function verifyForgotPasswordOtp({ tenantUsername, email, otp }) {
  const { data } = await authClient.post('/auth/verify-otp', {
    tenantUsername,
    email,
    otp,
  })
  return data
}

export async function changePasswordRequest({
  tenantUsername,
  email,
  newPassword,
  otp,
  currentPassword,
}) {
  const payload = {
    tenantUsername,
    email,
    newPassword,
  }

  if (otp) {
    payload.otp = otp
  }

  if (currentPassword) {
    payload.currentPassword = currentPassword
  }

  const { data } = await authClient.post('/auth/change-password', payload)
  return data
}


